import React, { memo, useCallback, useRef, useState } from "react";
import { useResponsive } from "../responsive/index.js";
import { Slider } from "../Slider/Slider.jsx";
import { BinIcon } from "../icon/Icon.jsx";
import { Tooltip } from "../Tooltip/Tooltip.jsx";
import {
    InfoIconSliderWrapperStyled,
    InfoIconTooltipWrapperStyled,
    InfoIconWrapperStyled
} from "./styled/InfoIconStyled.js";

/**
 * aka "Ишечка"
 */
export const InfoIcon = memo((props) => {
    const {
        children,
        title,
    } = props;
    const {isSmallMaxWidth} = useResponsive();
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipLeaveTimer = useRef();

    const handleMouseLeave = useCallback(() => {
        tooltipLeaveTimer.current = setTimeout(() => {
            setShowTooltip(false);
        }, 300);
    }, []);

    const handleMouseEnter = useCallback(() => {
        if (tooltipLeaveTimer.current) {
            clearTimeout(tooltipLeaveTimer.current);
            tooltipLeaveTimer.current = null;
        }
        setShowTooltip(true);
    }, [])

    return isSmallMaxWidth ? (
            <Slider
                    headerContentComponent={
                        <div className="d-flex justify-content-between align-items-center w-100">
                            {!!title && <h5 className="mb-0">{title}</h5>}
                        </div>
                    }
                    style={{background: 'var(--color-surface-secondary)'}}
                    showCloseButton={true}
                    toggleComponent={
                        <InfoIconWrapperStyled>
                            <BinIcon name="IcInfoCircle"/>
                        </InfoIconWrapperStyled>}
            >
                <InfoIconSliderWrapperStyled>
                    {children}
                </InfoIconSliderWrapperStyled>
            </Slider>
    ) : (
            <Tooltip
                    placement="top"
                    flip
                    tooltipComponent={<InfoIconTooltipWrapperStyled onMouseEnter={handleMouseEnter}
                                                                    onMouseLeave={handleMouseLeave}>{children}</InfoIconTooltipWrapperStyled>}
                    show={showTooltip}
            >
                <InfoIconWrapperStyled
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                >
                    <BinIcon name="IcInfoCircle"/>
                </InfoIconWrapperStyled>
            </Tooltip>
    );
});
